import { backendUrl } from './../../env-config'
import { authAxios } from './../../helpers/axiosAuthInterceptor'

export const getDashboardStats = async () => {
  return await authAxios.get(`${backendUrl}/super-admin/dashboard/stats`)
}
